import { render } from "./noteSubjectDetail.vue?vue&type=template&id=59b67224"
import script from "./noteSubjectDetail.vue?vue&type=script&lang=js"
export * from "./noteSubjectDetail.vue?vue&type=script&lang=js"

import "./noteSubjectDetail.vue?vue&type=style&index=0&id=59b67224&lang=scss"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/notes/noteSubjectDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "59b67224"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('59b67224', __exports__)) {
    console.log('reload')
    api.reload('59b67224', __exports__)
  }
  
  module.hot.accept("./noteSubjectDetail.vue?vue&type=template&id=59b67224", () => {
    console.log('re-render')
    api.rerender('59b67224', render)
  })

}


export default __exports__